<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Carritos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Administración de Carritos en Nube

    //- Modal de detalle del carrito
    v-dialog(v-model='dialogDetalle', persistent max-width='800px')
      v-card(style='background-color:white !important;')
        v-card-title.justify-center(style="background: black; color: white; padding: 12px 18px;")
          span.headline(style="font-size: 18px !important;") Detalle del Carrito - {{ itemSel ? itemSel.keyDisplay : '' }}
          v-spacer
          v-btn(icon dark @click='dialogDetalle = false')
            v-icon close
        v-card-text(style="padding: 20px;")
          v-layout(row wrap v-if="itemSel")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="itemSel.ven_des" label="Nombre del Vendedor:" prepend-inner-icon="person")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="itemSel.co_ven" label="Código del Vendedor:" prepend-inner-icon="badge")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="itemSel.clienteDisplay" label="Cliente:" prepend-inner-icon="business")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="itemSel.condicionDisplay" label="Condición de Pago:" prepend-inner-icon="payment")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="itemSel.fechaDisplay" label="Última Actualización:" prepend-inner-icon="event")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="itemSel.keyDisplay" label="Identificador de Carrito:" prepend-inner-icon="shopping_cart")
            v-flex(xs12 v-if="itemSel.descrip")
              v-textarea(outline readonly v-model="itemSel.descrip" label="Observación / Descripción:" prepend-inner-icon="notes" rows="2")

            v-flex(xs12 style="margin-top: 10px;")
              div(style="font-weight: bold; font-size: 14px; color: #1e293b; margin-bottom: 8px;") Artículos en el Carrito ({{ itemSel.articulos ? itemSel.articulos.length : 0 }}):
              v-data-table(:headers="headersArticulos" :items="itemSel.articulos" hide-actions class="elevation-1" style="border-radius: 8px; overflow: hidden;")
                template(v-slot:items="p")
                  td.text-xs-center(style="font-weight: bold; color: #0284c7;") {{ p.item.co_art }}
                  td.text-xs-left {{ p.item.art_des }}
                  td.text-xs-center {{ p.item.unidad || 'UND' }}
                  td.text-xs-center(style="font-weight: bold;") {{ p.item.cant }}
                  td.text-xs-right $ {{ formatoMonto(obtenerPrecioArt(p.item)) }}
                  td.text-xs-right(style="font-weight: bold; color: #10b981;") $ {{ formatoMonto(obtenerTotalArt(p.item)) }}

            v-flex(xs12 style="margin-top: 16px; background: #f8fafc; padding: 12px 18px; border-radius: 8px;")
              v-layout(row wrap justify-end text-xs-right)
                v-flex(xs12 sm4)
                  div(style="font-size: 13px; color: #64748b;") Subtotal:
                  div(style="font-size: 15px; font-weight: 600;") $ {{ formatoMonto(itemSel.subtotal) }}
                v-flex(xs12 sm4)
                  div(style="font-size: 13px; color: #64748b;") IVA:
                  div(style="font-size: 15px; font-weight: 600;") $ {{ formatoMonto(itemSel.iva) }}
                v-flex(xs12 sm4)
                  div(style="font-size: 13px; color: #0f172a; font-weight: bold;") Total:
                  div(style="font-size: 18px; font-weight: bold; color: #10b981;") $ {{ formatoMonto(itemSel.total) }}

        v-card-actions(style="padding: 12px 20px; background: #f1f5f9;")
          v-btn(color="red" flat @click="eliminarCarrito(itemSel)")
            v-icon(small style="margin-right: 4px;") delete
            | Eliminar de la nube
          v-spacer
          v-btn(color="black" flat @click='dialogDetalle = false') Cerrar

    //- Contenido principal
    v-container(fluid style="padding: 16px 20px;")
      //- Tarjetas de resumen (KPIs)
      v-layout(row wrap style="margin-bottom: 16px;")
        v-flex(xs12 sm6 md3 style="padding: 6px;")
          v-card(color="white" style="border-radius: 10px; border-left: 5px solid #0284c7; padding: 14px 16px;" class="elevation-2")
            div(style="font-size: 12px; color: #64748b; font-weight: 600; text-transform: uppercase;") Total Carritos
            div(style="font-size: 26px; font-weight: bold; color: #0284c7; margin-top: 4px;") {{ carritos.length }}
        v-flex(xs12 sm6 md3 style="padding: 6px;")
          v-card(color="white" style="border-radius: 10px; border-left: 5px solid #8b5cf6; padding: 14px 16px;" class="elevation-2")
            div(style="font-size: 12px; color: #64748b; font-weight: 600; text-transform: uppercase;") Vendedores con Carritos
            div(style="font-size: 26px; font-weight: bold; color: #8b5cf6; margin-top: 4px;") {{ totalVendedoresConCarritos }}
        v-flex(xs12 sm6 md3 style="padding: 6px;")
          v-card(color="white" style="border-radius: 10px; border-left: 5px solid #f59e0b; padding: 14px 16px;" class="elevation-2")
            div(style="font-size: 12px; color: #64748b; font-weight: 600; text-transform: uppercase;") Clientes con Carritos
            div(style="font-size: 26px; font-weight: bold; color: #f59e0b; margin-top: 4px;") {{ totalClientesConCarritos }}
        v-flex(xs12 sm6 md3 style="padding: 6px;")
          v-card(color="white" style="border-radius: 10px; border-left: 5px solid #10b981; padding: 14px 16px;" class="elevation-2")
            div(style="font-size: 12px; color: #64748b; font-weight: 600; text-transform: uppercase;") Total en Carritos ($)
            div(style="font-size: 26px; font-weight: bold; color: #10b981; margin-top: 4px;") $ {{ formatoMonto(montoTotalAcumulado) }}

      //- Barra de filtros y controles
      v-card(color="white" style="border-radius: 10px; padding: 16px; margin-bottom: 20px;" class="elevation-2")
        v-layout(row wrap align-center)
          v-flex(xs12 md4 style="padding: 6px;")
            v-text-field(outline v-model="filtroBusqueda" label="Buscar nombre de vendedor, cliente o artículo..." prepend-inner-icon="search" clearable hide-details)
          v-flex(xs12 sm6 md3 style="padding: 6px;")
            v-select(outline :items="opcionesVendedores" v-model="filtroVendedor" label="Filtrar por Vendedor:" prepend-inner-icon="person" hide-details)
          v-flex(xs12 sm6 md3 style="padding: 6px;")
            v-select(outline :items="['Vista Jerárquica (Vendedor -> Cliente)', 'Listado General (Tabla)']" v-model="tipoVista" label="Modo de Visualización:" prepend-inner-icon="view_compact" hide-details)
          v-flex(xs12 md2 style="padding: 6px;" text-xs-center)
            v-btn(color="#0284c7" dark icon @click="recargarTodo" title="Actualizar datos")
              v-icon refresh
            v-btn(small outline color="#0284c7" @click="toggleExpandirTodo" style="text-transform: none; border-radius: 6px; margin-left: 4px;" title="Expandir/colapsar artículos")
              v-icon(small style="margin-right: 2px;") {{ todosExpandidos ? 'unfold_less' : 'unfold_more' }}
              | {{ todosExpandidos ? 'Colapsar arts.' : 'Ver todos arts.' }}

      //- Estado de carga
      div(v-if="loading" style="text-align: center; padding: 50px 0;")
        v-progress-circular(indeterminate color="#0284c7" size="64")
        div(style="margin-top: 14px; font-size: 15px; color: #64748b;") Cargando carritos y vendedores de la nube...

      //- Sin resultados
      div(v-else-if="carritosFiltrados.length === 0" style="text-align: center; padding: 60px 0; background: white; border-radius: 10px;" class="elevation-1")
        v-icon(size="64" color="grey lighten-1") shopping_cart
        div(style="margin-top: 14px; font-size: 18px; font-weight: bold; color: #334155;") No se encontraron carritos en la nube
        div(style="font-size: 14px; color: #94a3b8; margin-top: 6px;") Intenta cambiar los filtros seleccionados o verifica que los vendedores hayan guardado pedidos en la nube.

      //- VISTA 1: JERÁRQUICA (Vendedor con Nombre Destacado -> Clientes -> Carritos con Artículos)
      div(v-else-if="tipoVista === 'Vista Jerárquica (Vendedor -> Cliente)'")
        v-expansion-panel(expand style="border-radius: 10px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.06);")
          v-expansion-panel-content(v-for="(grupoVen, i) in arbolCarritos" :key="grupoVen.co_ven" style="background: white; margin-bottom: 6px; border-radius: 8px; border: 1px solid #e2e8f0;")
            template(v-slot:header)
              v-layout(row wrap align-center style="padding: 6px 0;")
                v-flex(xs12 sm5)
                  div(style="display: flex; align-items: center; gap: 12px;")
                    v-avatar(size="42" color="#0284c7" style="color: white; font-weight: bold; font-size: 14px;")
                      | {{ grupoVen.ven_des ? grupoVen.ven_des.charAt(0).toUpperCase() : 'V' }}
                    div
                      div(style="font-weight: 800; font-size: 16px; color: #0f172a; text-transform: uppercase;") {{ grupoVen.ven_des }}
                      div(style="font-size: 12px; color: #64748b; font-weight: 500;")
                        v-icon(x-small color="grey") badge
                        span(style="margin-left: 4px;") Vendedor Código: 
                        b(style="color: #0284c7;") {{ grupoVen.co_ven }}
                v-flex(xs6 sm3 text-xs-center)
                  v-chip(small color="#e0f2fe" text-color="#0369a1" style="font-weight: 600;")
                    | {{ grupoVen.clientes.length }} {{ grupoVen.clientes.length === 1 ? 'Cliente' : 'Clientes' }}
                  v-chip(small color="#f1f5f9" text-color="#334155" style="font-weight: 600; margin-left: 6px;")
                    | {{ grupoVen.totalCarritos }} {{ grupoVen.totalCarritos === 1 ? 'Carrito' : 'Carritos' }}
                v-flex(xs6 sm4 text-xs-right)
                  div(style="font-size: 11px; color: #64748b; text-transform: uppercase;") Monto Acumulado
                  div(style="font-size: 18px; font-weight: bold; color: #10b981;") $ {{ formatoMonto(grupoVen.totalMonto) }}

            //- Contenido del Vendedor: Lista de Clientes y sus Carritos
            v-card(color="#f8fafc" style="padding: 16px 20px; border-top: 1px solid #e2e8f0;")
              div(v-for="cli in grupoVen.clientes" :key="cli.co_cli" style="background: white; border-radius: 8px; padding: 14px 18px; margin-bottom: 14px; border: 1px solid #cbd5e1; box-shadow: 0 2px 4px rgba(0,0,0,0.03);")
                //- Encabezado de Cliente
                v-layout(row wrap align-center style="border-bottom: 1px solid #f1f5f9; padding-bottom: 10px; margin-bottom: 12px;")
                  v-flex(xs12 sm8)
                    div(style="display: flex; align-items: center; gap: 8px;")
                      v-icon(color="#0284c7" small) business
                      span(style="font-weight: bold; font-size: 15px; color: #1e293b;") {{ cli.cli_des }}
                      span(style="background: #e2e8f0; color: #475569; font-size: 11px; padding: 2px 6px; border-radius: 4px; font-weight: 600;") {{ cli.co_cli }}
                  v-flex(xs12 sm4 text-xs-right)
                    span(style="font-size: 12px; color: #64748b; font-weight: 600;") Carritos activos: 
                    v-chip(small color="#dcfce7" text-color="#15803d" style="font-weight: bold;") {{ cli.carritos.length }}

                //- Tarjetas de Carritos del Cliente
                v-layout(row wrap)
                  v-flex(xs12 md6 lg6 v-for="car in cli.carritos" :key="car.key" style="padding: 6px;")
                    v-card(style="border: 1px solid #e2e8f0; border-radius: 8px; padding: 14px 16px; background: #ffffff; transition: all 0.2s;" class="elevation-1 hover-card")
                      v-layout(row wrap justify-space-between align-center)
                        v-flex(xs8)
                          div(style="display: flex; align-items: center; gap: 6px;")
                            v-icon(color="#f59e0b" small) shopping_cart
                            span(style="font-weight: bold; font-size: 15px; color: #0284c7;") {{ car.keyDisplay }}
                        v-flex(xs4 text-xs-right)
                          span(style="font-size: 17px; font-weight: bold; color: #10b981;") $ {{ formatoMonto(car.total) }}

                      //- Nombre del vendedor en la tarjeta
                      div(style="font-size: 12px; color: #334155; margin-top: 6px; display: flex; align-items: center; gap: 4px;")
                        v-icon(x-small color="#0284c7") person
                        span Vendedor:
                        strong(style="color: #0f172a;") {{ car.ven_des }}
                        span(style="color: #64748b; font-size: 11px;") (Cod: {{ car.co_ven }})

                      div(style="font-size: 12px; color: #64748b; margin-top: 4px;")
                        v-icon(x-small color="grey") event
                        span(style="margin-left: 4px;") {{ car.fechaDisplay }}

                      div(style="font-size: 12px; color: #334155; margin-top: 4px; display: flex; justify-content: space-between;")
                        span(style="font-weight: 600; color: #0369a1;") {{ car.articulos ? car.articulos.length : 0 }} artículos en el carrito
                        span(v-if="car.condicionDisplay" style="color: #64748b; font-style: italic;") Condición: {{ car.condicionDisplay }}

                      //- Sección de Artículos que tiene el Carrito
                      div(style="margin-top: 10px; background: #f8fafc; border-radius: 6px; padding: 10px 12px; border: 1px solid #e2e8f0;")
                        div(style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;")
                          span(style="font-size: 12px; font-weight: bold; color: #1e293b;") Artículos del carrito:
                          v-btn(small flat color="#0284c7" @click="toggleArticulos(car.key)" style="margin: 0; padding: 0 4px; height: 24px; text-transform: none; font-size: 11px;")
                            v-icon(small style="margin-right: 2px;") {{ mostrarArticulos[car.key] ? 'expand_less' : 'expand_more' }}
                            | {{ mostrarArticulos[car.key] ? 'Ocultar' : 'Ver ' + (car.articulos ? car.articulos.length : 0) + ' artículos' }}

                        //- Vista expandida con tabla de artículos
                        div(v-if="mostrarArticulos[car.key]")
                          div(v-if="!car.articulos || car.articulos.length === 0" style="font-size: 12px; color: #94a3b8; font-style: italic; padding: 8px 0;")
                            | Este carrito no posee artículos registrados.
                          div(v-else style="max-height: 240px; overflow-y: auto; padding-right: 4px;")
                            table(style="width: 100%; border-collapse: collapse; font-size: 12px;")
                              thead
                                tr(style="border-bottom: 1px solid #cbd5e1; color: #64748b; text-align: left; background: #f1f5f9;")
                                  th(style="padding: 4px 6px;") Cant.
                                  th(style="padding: 4px 6px;") Código / Descripción
                                  th(style="padding: 4px 6px; text-align: right;") Precio
                                  th(style="padding: 4px 6px; text-align: right;") Total
                              tbody
                                tr(v-for="(art, idx) in car.articulos" :key="idx" style="border-bottom: 1px dashed #e2e8f0;")
                                  td(style="padding: 6px; font-weight: bold; color: #0284c7; vertical-align: top;") {{ art.cant }} {{ art.unidad || '' }}
                                  td(style="padding: 6px; vertical-align: top;")
                                    div(style="font-weight: 600; color: #0f172a;") {{ art.art_des }}
                                    div(style="font-size: 11px; color: #64748b;") {{ art.co_art }}
                                  td(style="padding: 6px; text-align: right; color: #475569; vertical-align: top;") ${{ formatoMonto(obtenerPrecioArt(art)) }}
                                  td(style="padding: 6px; text-align: right; font-weight: bold; color: #10b981; vertical-align: top;") ${{ formatoMonto(obtenerTotalArt(art)) }}

                        //- Vista previa si está colapsado (primeros artículos)
                        div(v-else-if="car.articulos && car.articulos.length > 0")
                          div(v-for="(art, idx) in car.articulos.slice(0, 2)" :key="idx" style="font-size: 11px; color: #475569; padding: 2px 0; display: flex; justify-content: space-between;")
                            span(style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 70%;")
                              b(style="color: #0284c7;") {{ art.cant }}x 
                              | {{ art.art_des }}
                            span(style="font-weight: 600; color: #10b981;") ${{ formatoMonto(obtenerTotalArt(art)) }}
                          div(v-if="car.articulos.length > 2" style="font-size: 11px; color: #64748b; margin-top: 2px; font-style: italic;")
                            | +{{ car.articulos.length - 2 }} artículo(s) más...

                      v-divider(style="margin: 10px 0 8px 0;")

                      v-layout(row align-center justify-space-between)
                        v-btn(small color="#0284c7" outline @click="verDetalle(car)" style="margin: 0; text-transform: none; border-radius: 6px;")
                          v-icon(small style="margin-right: 4px;") open_in_new
                          | Modal Detallado
                        v-btn(small color="red" flat icon @click="eliminarCarrito(car)" title="Eliminar de la nube" style="margin: 0;")
                          v-icon(small) delete

      //- VISTA 2: LISTADO GENERAL (Tabla con Nombre de Vendedor y Fila Expandible)
      div(v-else)
        v-card(color="white" style="border-radius: 10px; overflow: hidden;" class="elevation-2")
          v-data-table(:headers="headersTabla" :items="carritosFiltrados" item-key="key" :rows-per-page-items="[10, 25, 50, 100]" class="elevation-0")
            template(v-slot:items="props")
              tr(@click="props.expanded = !props.expanded" style="cursor: pointer;")
                td(style="color: #0f172a;")
                  div(style="font-size: 14px; font-weight: bold; color: #0f172a; text-transform: uppercase;") {{ props.item.ven_des }}
                  div(style="font-size: 11px; color: #64748b;") Código: {{ props.item.co_ven }}
                td
                  div(style="font-weight: bold; color: #0284c7;") {{ props.item.clienteDisplay }}
                  div(style="font-size: 11px; color: #64748b;") Cod: {{ props.item.co_cli }}
                td.text-xs-center
                  v-chip(small color="#e0f2fe" text-color="#0369a1" style="font-weight: bold;") {{ props.item.keyDisplay }}
                td.text-xs-center(style="font-weight: 600;")
                  v-chip(small color="#f1f5f9" text-color="#334155")
                    v-icon(x-small left color="#0284c7") shopping_bag
                    | {{ props.item.articulos ? props.item.articulos.length : 0 }} arts.
                td.text-xs-right(style="font-weight: bold; color: #10b981; font-size: 14px;") $ {{ formatoMonto(props.item.total) }}
                td.text-xs-center(style="font-size: 12px; color: #64748b;") {{ props.item.fechaDisplay }}
                td.text-xs-center
                  v-btn(small icon color="#0284c7" @click.stop="props.expanded = !props.expanded" :title="props.expanded ? 'Ocultar artículos' : 'Ver artículos'")
                    v-icon(small) {{ props.expanded ? 'expand_less' : 'expand_more' }}
                  v-btn(small icon color="#0284c7" @click.stop="verDetalle(props.item)" title="Ver detalle en ventana")
                    v-icon(small) open_in_new
                  v-btn(small icon color="red" @click.stop="eliminarCarrito(props.item)" title="Eliminar de la nube")
                    v-icon(small) delete

            //- Fila expandible con la tabla completa de artículos del carrito
            template(v-slot:expand="props")
              v-card(flat style="background: #f8fafc; padding: 14px 24px; border-bottom: 2px solid #e2e8f0;")
                v-layout(row wrap align-center justify-space-between style="margin-bottom: 10px;")
                  v-flex(xs12 sm8)
                    span(style="font-weight: bold; font-size: 14px; color: #1e293b;")
                      | Artículos del {{ props.item.keyDisplay }} (Vendedor: {{ props.item.ven_des }} - Cliente: {{ props.item.clienteDisplay }}):
                  v-flex(xs12 sm4 text-xs-right)
                    span(style="font-size: 13px; color: #64748b;") Subtotal: ${{ formatoMonto(props.item.subtotal) }} | 
                    span(style="font-size: 14px; font-weight: bold; color: #10b981;") Total: ${{ formatoMonto(props.item.total) }}

                v-data-table(:headers="headersArticulos" :items="props.item.articulos" hide-actions class="elevation-1" style="border-radius: 8px; overflow: hidden; background: white;")
                  template(v-slot:items="p")
                    td.text-xs-center(style="font-weight: bold; color: #0284c7;") {{ p.item.co_art }}
                    td.text-xs-left {{ p.item.art_des }}
                    td.text-xs-center {{ p.item.unidad || 'UND' }}
                    td.text-xs-center(style="font-weight: bold;") {{ p.item.cant }}
                    td.text-xs-right $ {{ formatoMonto(obtenerPrecioArt(p.item)) }}
                    td.text-xs-right(style="font-weight: bold; color: #10b981;") $ {{ formatoMonto(obtenerTotalArt(p.item)) }}
</template>

<script>
import Api from "@/services/methods";
import moment from "moment";

export default {
  name: "Carritos",
  data() {
    return {
      loading: false,
      carritos: [],
      vendedoresMap: {},
      filtroBusqueda: "",
      filtroVendedor: "Todos",
      tipoVista: "Vista Jerárquica (Vendedor -> Cliente)",
      dialogDetalle: false,
      itemSel: null,
      mostrarArticulos: {}, // Map para controlar qué carritos muestran sus artículos directamente

      headersTabla: [
        { text: "Vendedor", value: "ven_des", align: "left" },
        { text: "Cliente", value: "clienteDisplay", align: "left" },
        { text: "Carrito", value: "keyDisplay", align: "center" },
        { text: "Artículos", value: "articulos.length", align: "center" },
        { text: "Total ($)", value: "total", align: "right" },
        { text: "Última Actualización", value: "fechaDisplay", align: "center" },
        { text: "Acciones", sortable: false, align: "center" }
      ],

      headersArticulos: [
        { text: "Código", value: "co_art", align: "center" },
        { text: "Descripción", value: "art_des", align: "left" },
        { text: "Unidad", value: "unidad", align: "center" },
        { text: "Cantidad", value: "cant", align: "center" },
        { text: "Precio Unit. ($)", value: "precio", align: "right" },
        { text: "Total ($)", value: "totalRenglon", align: "right" }
      ]
    };
  },
  created() {
    this.recargarTodo();
  },
  computed: {
    todosExpandidos() {
      if (this.carritosNormalizados.length === 0) return false;
      return this.carritosNormalizados.every(c => this.mostrarArticulos[c.key]);
    },

    // Normalizar carritos con campos amigables para visualización y búsqueda
    carritosNormalizados() {
      return this.carritos.map(item => {
        const ped = item.pedido || {};
        const cli = ped.cliente || {};
        const ven = ped.vendedor || {};

        const co_ven = (item.co_ven || ven.co_ven || "").toString().trim();
        
        // Obtener el nombre del vendedor desde el objeto o desde el mapa de vendedores
        let ven_des = (item.ven_des || ven.ven_des || "").toString().trim();
        if (!ven_des || ven_des === "null" || ven_des === "undefined" || ven_des === co_ven) {
          const raw = co_ven;
          ven_des = this.vendedoresMap[raw] || 
                    this.vendedoresMap[raw.padStart(3, "0")] || 
                    this.vendedoresMap[parseInt(raw, 10).toString()] || 
                    `Vendedor ${co_ven}`;
        }

        const co_cli = (item.co_cli || cli.co_cli || "").toString().trim();
        const cli_des = (cli.cli_des || `Cliente ${co_cli}`).toString().trim();
        const key = (item.key || "").toString().trim();

        // Extraer número de pedido amigable de la key (ej: pedido_C123_1 -> Pedido 1)
        let keyDisplay = key;
        if (key.includes("_")) {
          const parts = key.split("_");
          const last = parts[parts.length - 1];
          if (!isNaN(last)) {
            keyDisplay = `Pedido ${last}`;
          }
        }

        const fechaRaw = item.updatedAt || item.fechaC;
        const fechaDisplay = fechaRaw ? moment(fechaRaw).format("DD/MM/YYYY hh:mm A") : "N/A";

        return {
          ...item,
          co_ven,
          ven_des,
          vendedorDisplay: `${ven_des} (Cod: ${co_ven})`,
          co_cli,
          cli_des,
          clienteDisplay: `[${co_cli}] ${cli_des}`,
          key,
          keyDisplay,
          fechaDisplay,
          condicionDisplay: ped.co_cond || ped.coCond || "",
          descrip: ped.descrip || "",
          subtotal: ped.subtotal || 0,
          iva: ped.iva || 0,
          total: ped.total || 0,
          articulos: ped.articulos || []
        };
      });
    },

    // Opciones para el selector de vendedores mostrando el nombre completo
    opcionesVendedores() {
      const vMap = new Map();
      vMap.set("Todos", "Todos");
      this.carritosNormalizados.forEach(c => {
        if (c.co_ven) {
          vMap.set(c.co_ven, `${c.ven_des} (${c.co_ven})`);
        }
      });
      return Array.from(vMap.entries()).map(([value, text]) => ({ text, value }));
    },

    // Filtrar carritos según búsqueda y vendedor seleccionado
    carritosFiltrados() {
      let res = this.carritosNormalizados;

      if (this.filtroVendedor && this.filtroVendedor !== "Todos") {
        res = res.filter(c => c.co_ven === this.filtroVendedor);
      }

      if (this.filtroBusqueda && this.filtroBusqueda.trim().length > 0) {
        const q = this.filtroBusqueda.toLowerCase().trim();
        res = res.filter(c => {
          const matchV = c.ven_des.toLowerCase().includes(q) || c.co_ven.toLowerCase().includes(q);
          const matchC = c.cli_des.toLowerCase().includes(q) || c.co_cli.toLowerCase().includes(q);
          const matchK = c.key.toLowerCase().includes(q) || c.keyDisplay.toLowerCase().includes(q);
          const matchArt = (c.articulos || []).some(a => {
            const artDes = (a.art_des || "").toLowerCase();
            const coArt = (a.co_art || "").toLowerCase();
            return artDes.includes(q) || coArt.includes(q);
          });
          return matchV || matchC || matchK || matchArt;
        });
      }

      return res;
    },

    // Árbol jerárquico Vendedor -> Clientes -> Carritos
    arbolCarritos() {
      const grupos = {};

      this.carritosFiltrados.forEach(c => {
        const venKey = c.co_ven || "S/V";
        if (!grupos[venKey]) {
          grupos[venKey] = {
            co_ven: c.co_ven,
            ven_des: c.ven_des,
            totalCarritos: 0,
            totalMonto: 0,
            clientesMap: {}
          };
        }

        const gVen = grupos[venKey];
        gVen.totalCarritos += 1;
        gVen.totalMonto += parseFloat(c.total) || 0;

        const cliKey = c.co_cli || "S/C";
        if (!gVen.clientesMap[cliKey]) {
          gVen.clientesMap[cliKey] = {
            co_cli: c.co_cli,
            cli_des: c.cli_des,
            carritos: []
          };
        }

        gVen.clientesMap[cliKey].carritos.push(c);
      });

      // Convertir a arreglos ordenados
      return Object.values(grupos).map(g => {
        return {
          co_ven: g.co_ven,
          ven_des: g.ven_des,
          totalCarritos: g.totalCarritos,
          totalMonto: g.totalMonto,
          clientes: Object.values(g.clientesMap)
        };
      });
    },

    // KPIs acumulados
    totalVendedoresConCarritos() {
      const s = new Set();
      this.carritosNormalizados.forEach(c => {
        if (c.co_ven) s.add(c.co_ven);
      });
      return s.size;
    },

    totalClientesConCarritos() {
      const s = new Set();
      this.carritosNormalizados.forEach(c => {
        if (c.co_cli) s.add(c.co_cli);
      });
      return s.size;
    },

    montoTotalAcumulado() {
      return this.carritosNormalizados.reduce((acc, c) => acc + (parseFloat(c.total) || 0), 0);
    }
  },
  methods: {
    recargarTodo() {
      this.cargarVendedores();
      this.cargarCarritos();
    },

    cargarVendedores() {
      Api.get("vendedor")
        .then(res => {
          const list = Array.isArray(res.data) ? res.data : (res.data.data || []);
          const map = {};
          list.forEach(v => {
            if (v.co_ven && v.ven_des) {
              const raw = v.co_ven.toString().trim();
              const nom = v.ven_des.toString().trim();
              map[raw] = nom;
              const num = parseInt(raw, 10);
              if (!isNaN(num)) {
                map[num.toString()] = nom;
                map[num.toString().padStart(3, "0")] = nom;
              }
            }
          });
          this.vendedoresMap = map;
        })
        .catch(err => {
          console.error("Error al cargar vendedores:", err);
        });
    },

    cargarCarritos() {
      this.loading = true;
      Api.get("pedido/carrito")
        .then(res => {
          this.loading = false;
          if (res && res.data) {
            this.carritos = Array.isArray(res.data) ? res.data : (res.data.data || []);
          } else if (Array.isArray(res)) {
            this.carritos = res;
          } else {
            this.carritos = [];
          }
        })
        .catch(err => {
          this.loading = false;
          console.error("Error al cargar carritos:", err);
          this.$swal.fire({
            type: "error",
            title: "Error",
            text: "No se pudieron obtener los carritos de la nube."
          });
        });
    },

    toggleArticulos(key) {
      this.$set(this.mostrarArticulos, key, !this.mostrarArticulos[key]);
    },

    toggleExpandirTodo() {
      const estadoActual = this.todosExpandidos;
      const nuevo = {};
      if (!estadoActual) {
        this.carritosNormalizados.forEach(c => {
          nuevo[c.key] = true;
        });
      }
      this.mostrarArticulos = nuevo;
    },

    verDetalle(item) {
      this.itemSel = item;
      this.dialogDetalle = true;
    },

    eliminarCarrito(item) {
      this.$swal.fire({
        title: "¿Eliminar carrito de la nube?",
        html: `¿Estás seguro de eliminar el <b>${item.keyDisplay}</b> del cliente <b>${item.clienteDisplay}</b>?<br><br>Esta acción no se puede deshacer.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          Api.post("pedido/carrito/eliminar", {
            key: item.key,
            co_ven: item.co_ven
          })
            .then(res => {
              this.loading = false;
              if (this.dialogDetalle) this.dialogDetalle = false;
              this.$swal.fire("Eliminado", "El carrito ha sido eliminado de la nube.", "success");
              this.cargarCarritos();
            })
            .catch(err => {
              this.loading = false;
              console.error("Error al eliminar carrito:", err);
              this.$swal.fire("Error", "No se pudo eliminar el carrito.", "error");
            });
        }
      });
    },

    formatoMonto(m) {
      if (m == null || isNaN(m)) return "0.00";
      return parseFloat(m).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    obtenerPrecioArt(art) {
      if (art.precio && typeof art.precio === "object") {
        return parseFloat(art.precio.monto) || 0;
      }
      return parseFloat(art.precio) || 0;
    },

    obtenerTotalArt(art) {
      const cant = parseFloat(art.cant) || 0;
      const prec = this.obtenerPrecioArt(art);
      return cant * prec;
    }
  }
};
</script>

<style scoped>
.hover-card:hover {
  border-color: #0284c7 !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(2, 132, 199, 0.12) !important;
}
</style>
